import * as React from "react";
import { IdStyles } from "../../less/IdStyles";
import { IconWithText } from "../generic/icon-with-text/IconWithText";
import { IdIcon } from "../generic/icon/IdIcon";
import { TimerCountdown } from "../generic/timer/TimerCountdown";
export var TimeRemaining = function (_a) {
    var backgroundClassName = _a.backgroundClassName, backgroundSize = _a.backgroundSize, fontClassName = _a.fontClassName, remainingTime = _a.remainingTime, className = _a.className;
    return (React.createElement("div", { className: "flex flex--guts tournament-timer" },
        React.createElement(IconWithText, { icon: IdIcon.TimeIcn, styleId: IdStyles.IconSmall, backgroundClassName: backgroundClassName, backgroundSize: backgroundSize, className: className },
            React.createElement(TimerCountdown, { remainingTime: remainingTime, className: fontClassName !== undefined
                    ? fontClassName
                    : IdStyles.TextBoldSecondaryOutline }))));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/time/TimeRemaining.tsx
// module id = 228
// module chunks = 3